<template>
  <div class="wrapper">
    <v-select
      :value="selectedType"
      :items="generalTypes"
      item-text="label"
      :hide-details="true"
      dense
      outlined
      rounded
      append-icon="icon-arrow-down"
      full-width
      :menu-props="{
        contentClass: 'report-type-selector__menu',
        offsetY: true
      }"
      class="report-type-selector v-input--is-focused"
      @input="selectType"
    >
    </v-select>
    <div>
      <div
        v-if="isTopReport && isChartRoute"
        class="report-type-selector__checkboxes"
      >
        <TopChartSerieCheckbox
          v-for="serie in topChartSeries"
          :key="serie.value"
          v-bind="{ ...serie }"
          @toggle="toggleCheckbox"
        />
      </div>
      <div v-if="isTableRoute && searchingModes.groups" class="grouped-switch">
        <v-switch
          color="primary"
          :input-value="isGroupedData"
          hide-details
          @change="handleSwitch($event)"
          inset
          :label="$t('message.analytics.periodic.table.groupFacilities')"
        >
        </v-switch>
      </div>
    </div>
  </div>
</template>

<script>
import TopChartSerieCheckbox from "@/components/Analytics/Periodic/TopChartSerieCheckbox";

import { PERIODIC_REPORT_TYPE } from "@/enums/charts-type.enum";

export default {
  name: "PeriodicReportTypeSelector",
  components: { TopChartSerieCheckbox },
  props: {
    selectedType: {
      type: Number,
      required: true,
      validator: type => Object.values(PERIODIC_REPORT_TYPE).includes(type)
    },
    generalTypes: {
      type: Array,
      required: true,
      validator: typeObjs =>
        typeObjs.every(typeObj =>
          ["label", "value"].every(key => key in typeObj)
        )
    },
    topChartSeries: {
      type: Array,
      required: true,
      validator: series =>
        series.every(serie =>
          ["label", "color", "value", "state"].every(key => key in serie)
        )
    },
    isGroupedData: {
      type: Boolean,
      required: true
    },
    isTableRoute: {
      type: Boolean,
      default: true
    },
    isChartRoute: {
      type: Boolean,
      default: true
    },
    searchingModes: {
      type: Object,
      required: true
    }
  },

  computed: {
    isTopReport() {
      return this.selectedType === PERIODIC_REPORT_TYPE.TOP;
    }
  },

  methods: {
    selectType(type) {
      this.$emit("selected", type);
    },
    toggleCheckbox(value) {
      this.$emit("toggleCheckbox", value);
    },
    handleSwitch(value) {
      this.$emit("changeSwitch", !!value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables.scss";
.wrapper {
  display: flex;
  flex-direction: column;
  width: 400px;
  min-height: 112px;

  @media only screen and (max-width: 1600px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: unset;
    margin-bottom: $spacing;
  }
}

.report-type-selector {
  flex-grow: 0;

  &__checkboxes {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.grouped-switch {
  display: flex;
  justify-content: flex-end;

  &::v-deep .v-input > .v-input__control > .v-input__slot > label {
    @include font-size(12px);
    font-weight: 400;
    color: $text;
  }

  ::v-deep .v-input--selection-controls {
    @media only screen and (max-width: 1600px) {
      margin-top: 0;
      margin-left: auto;
    }
  }
}

::v-deep.report-type-selector {
  &.v-text-field--outlined.v-input--dense {
    > .v-input__control {
      > .v-input__slot {
        padding: 0 $spacing * 2;
        min-height: 46px;
        height: 46px;
        color: $text;
        @include font-size(14px);
        line-height: 17px;
        font-weight: 500;

        > .v-select__slot {
          > .v-input__append-inner {
            margin-top: 0;
            align-self: unset;
          }
        }
      }
    }
  }
}
</style>
